import { SelectItem, SelectItemWithDescription } from '@/types/fields';
import { ProductCategory } from '@/types/transaction';

export type PurposeOfTransferValue =
  | 'eFxOperation'
  | 'invoiceAndSupplierPayments'
  | 'professionalServices'
  | 'licensingAndRoyalties'
  | 'tradeFinance'
  | 'operationalExpenses'
  | 'technologyServices'
  | 'logisticsAndShipping'
  | 'marketingAndAdvertising'
  | 'payrollAndContractorPayments'
  | 'loanRepaymentAndInterest'
  | 'intercompanyTransfers'
  | 'taxesDutiesAndGovernmentFees'
  | 'commissionAndAgentFees'
  | 'capitalInjectionInvestment';

export const purposeOfTransferOptions: ReadonlyArray<
  SelectItemWithDescription<PurposeOfTransferValue>
> = [
  {
    value: 'eFxOperation',
    label: 'PURPOSE_OF_TRANSFER_EFX_OPERATION_LABEL',
    description: 'PURPOSE_OF_TRANSFER_EFX_OPERATION_DESCRIPTION',
  },
  {
    value: 'invoiceAndSupplierPayments',
    label: 'PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_LABEL',
    description: 'PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_DESCRIPTION',
  },
  {
    value: 'professionalServices',
    label: 'PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_LABEL',
    description: 'PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_DESCRIPTION',
  },
  {
    value: 'licensingAndRoyalties',
    label: 'PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_LABEL',
    description: 'PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_DESCRIPTION',
  },
  {
    value: 'tradeFinance',
    label: 'PURPOSE_OF_TRANSFER_TRADE_FINANCE_LABEL',
    description: 'PURPOSE_OF_TRANSFER_TRADE_FINANCE_DESCRIPTION',
  },
  {
    value: 'operationalExpenses',
    label: 'PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_LABEL',
    description: 'PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_DESCRIPTION',
  },
  {
    value: 'technologyServices',
    label: 'PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_LABEL',
    description: 'PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_DESCRIPTION',
  },
  {
    value: 'logisticsAndShipping',
    label: 'PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_LABEL',
    description: 'PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_DESCRIPTION',
  },
  {
    value: 'marketingAndAdvertising',
    label: 'PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_LABEL',
    description: 'PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_DESCRIPTION',
  },
  {
    value: 'payrollAndContractorPayments',
    label: 'PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_LABEL',
    description: 'PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_DESCRIPTION',
  },
  {
    value: 'loanRepaymentAndInterest',
    label: 'PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_LABEL',
    description: 'PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_DESCRIPTION',
  },
  {
    value: 'intercompanyTransfers',
    label: 'PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_LABEL',
    description: 'PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_DESCRIPTION',
  },
  {
    value: 'taxesDutiesAndGovernmentFees',
    label: 'PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_LABEL',
    description: 'PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_DESCRIPTION',
  },
  {
    value: 'commissionAndAgentFees',
    label: 'PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_LABEL',
    description: 'PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_DESCRIPTION',
  },
  {
    value: 'capitalInjectionInvestment',
    label: 'PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_LABEL',
    description: 'PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_DESCRIPTION',
  },
];

export const productCategoryOptions: ReadonlyArray<SelectItem<ProductCategory>> = [
  { value: ProductCategory.APPAREL, label: 'PRODUCT_CATEGORY_APPAREL' },
  { value: ProductCategory.ELECTRONICS, label: 'PRODUCT_CATEGORY_ELECTRONICS' },
  { value: ProductCategory.FOOD_AND_BEVERAGE, label: 'PRODUCT_CATEGORY_FOOD_AND_BEVERAGE' },
  { value: ProductCategory.FURNITURE, label: 'PRODUCT_CATEGORY_FURNITURE' },
  { value: ProductCategory.MACHINERY, label: 'PRODUCT_CATEGORY_MACHINERY' },
  { value: ProductCategory.RAW_MATERIALS, label: 'PRODUCT_CATEGORY_RAW_MATERIALS' },
  { value: ProductCategory.TEXTILES, label: 'PRODUCT_CATEGORY_TEXTILES' },
  { value: ProductCategory.TOYS, label: 'PRODUCT_CATEGORY_TOYS' },
  { value: ProductCategory.AUTOMOTIVE, label: 'PRODUCT_CATEGORY_AUTOMOTIVE' },
  { value: ProductCategory.COSMETICS, label: 'PRODUCT_CATEGORY_COSMETICS' },
  { value: ProductCategory.OTHER, label: 'PRODUCT_CATEGORY_OTHER' },
];
